<template>
  <div>
    <div class="content"></div>
    <div class="ying"></div>
    <div class="tck2" v-if="flag">
      <img src="@/assets/imagePai/gou.png" alt="" style="margin-top: 0.4rem" />
      <p>已完成儲值</p>
      <a class="out2" id="out2" @click="handleOk()">確認</a>
    </div>
    <div class="tck2 error" v-if="!flag">
      <img src="@/assets/imagePai/wenhao.png" alt="" />
      <p>{{ msg }}</p>
      <p class="notice"></p>
      <a href="javascript:;" class="out2" @click="handleOk()">確認</a>
    </div>
  </div>
</template>

<script>
import { getUrlParams } from "@/util/params";
import { orderStatus } from "@/api/game";
export default {
  data() {
    return {
      flag: false,
      msg: "",
    };
  },
  methods: {
    handleOk() {
      this.$router.push("/home");
    },
  },
  created() {
    // this.flag = true;
    const url = window.location.search;
    const is_success = getUrlParams(url);
    if (is_success.is_success == 3 && is_success.is_success) {
      if (is_success.msg) {
        const msg = decodeURIComponent(is_success.msg);
        this.msg = msg;
      }
      this.flag = true;
    }

    if (is_success.is_success == 0 && is_success.is_success) {
      if (is_success.msg) {
        const msg = decodeURIComponent(is_success.msg);
        this.msg = msg;
      }
    }

    console.log(this.flag);
  },
};
</script>

<style lang="less" scoped>
body {
  background: #cfcfcf;
}

.ying {
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 6;
  opacity: 0.8;
  position: absolute;
  top: 0;
  left: 0;
}

.content {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  /* background: url(./images/logo_bg.jpg) center no-repeat; */
}

.tck2 {
  text-align: center;
  width: 467px;
  height: 347px;
  position: absolute;
  background: url(../assets/imagePai/weichaxundao.png) no-repeat;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    text-align: center;
    font-size: 28px;
    font-weight: 600;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  a {
    width: 250px;
    height: 52px;
    background: url(../assets/imagePai/haode.png) no-repeat;
    display: block;
    color: #000;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    line-height: 52px;
  }
  img {
    width: 128px;
  }
}

.error {
  outline: none;
  background: url(../assets/imagePai/weichaxundao.png) no-repeat;
  img {
    width: 124px;
  }
  p {
    margin-top: 8px;
    color: #000;
    font-size: 26px;
    font-weight: 600;
    letter-spacing: 2px;
  }
  .notice {
    margin-top: 0;
    font-size: 15px;
    margin-bottom: 15px;
    color: #656a73;
    letter-spacing: 1px;
  }
}
</style>